/**
 * @file index
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import { createContext, useContext } from 'react';
var ComponentContext = createContext(null);
export var ComponentProvider = ComponentContext.Provider;
export function useComponents() {
    var runtime = useContext(ComponentContext);
    if (!runtime) {
        throw new Error('useComponents must be use under `ComponentProvider`');
    }
    return runtime;
}
